export default __webpack_public_path__ + "static/media/voguemagzine.049509d5.jpg";